var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.saveLoading,"spinner-small":"","spinner-variant":"secondary"}},[_c('click-edit',{attrs:{"default-value":`ID:${_vm.id}`,"value-label":`ID:${_vm.id}→Code: `,"value":_vm.dictCode.name},on:{"update:value":function($event){return _vm.$set(_vm.dictCode, "name", $event)},"inputBlur":_vm.doSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }